const defaultPosition = 'top-right';
const defaultType = 'info';
const validInputTypes = [
  'error',
  'success',
  'info',
  'warning',
];
const inputTypeMapping = {
  error: 'negative',
  success: 'positive',
  info: 'info',
  warning: 'warning',
};

function triggerNotification(Vue, message, type, position, dismissable = false, detail = null) {
  const options = {
    message,
    type,
    position: position || defaultPosition,
  };

  if (detail) options.detail = detail;

  // Smart timeout based on message length
  options.timeout = 2000 + (message.length + (detail?.length || 0)) * 32;

  if (dismissable) {
    options.timeout = 30000;
    options.actions = [
      {
        icon: 'close',
        handler: () => { },
      },
    ];
  }

  Vue.prototype.$q.notify(options);
}

function notifications(Vue, position) {
  const notify = type => (message, dismissable, details) => triggerNotification(Vue, message, type, position, dismissable, details);


  return {
    info: notify('info'),
    warning: notify('warning'),
    success: notify('positive'),
    error: notify('negative'),
    notify: (type, message, dismissable, details) => {
      notify(validInputTypes.includes(type) ? inputTypeMapping[type] : defaultType)(message, dismissable, details);
    },
  };
}

export default {
  install: (Vue) => {
    Vue.prototype.$notifyUserInteraction = notifications(Vue, 'top-right');
    Vue.prototype.$notifyMessage = notifications(Vue, 'bottom-right');
  },
};
